/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-table {
  display: block;
  position: relative;
  /* stylelint-disable */
  /* stylelint-enable */
}
.ux-table--hide-on-mobile {
  display: none;
}
@media only screen and (min-width: 768px) {
  .ux-table--hide-on-mobile {
    display: block;
  }
}
.ux-table--striped tr:nth-child(even) td {
  background-color: #eaedf2;
}
.ux-table--striped tr td {
  border: 0;
}
.ux-table ux-mobile-table {
  display: block;
}
@media only screen and (min-width: 768px) {
  .ux-table ux-mobile-table {
    display: none;
  }
}
.ux-table ux-mobile-table .ux-table-sort__icon {
  display: none;
}
.ux-table table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 auto;
  width: max-content;
}
.ux-table--same-column-width table {
  width: unset;
}
.ux-table td,
.ux-table th {
  background-color: #fff;
  border: 1px solid #cbcbcb;
  text-align: left;
  vertical-align: middle;
}
.ux-table td {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  font-size: 15px;
  border-left: 0;
  padding: 13px 20px;
  text-transform: none;
}
.ux-table--no-wrap {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ux-table__icon-text {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.ux-table__status-icon {
  font-size: 28px;
  margin-right: 8px;
}
.ux-table th {
  font-family: Frutiger-Bold, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  font-size: 13px;
  text-transform: uppercase;
  background-color: #c3cfd6;
  padding: 25px;
}
.ux-table thead tr {
  background-color: #c3cfd6;
}
.ux-table thead th,
.ux-table thead td {
  border-top: 0;
  border-right: 1px solid #9ea9b0;
  border-bottom: 1px solid #9ea9b0;
}
.ux-table tbody tr:nth-child(odd) td,
.ux-table tbody tr:nth-child(odd) th {
  background-color: #fff;
}
.ux-table td.first,
.ux-table tr td:first-child {
  font-size: inherit;
}
.ux-table tr > td:first-child {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
}
.ux-table tbody tr:hover td {
  background-color: #ecf0f3;
}
.ux-table tr {
  background-color: #fff;
}
.ux-table tr th:first-child,
.ux-table tr td:first-child {
  border-left: 0;
}
.ux-table tr th:last-child,
.ux-table tr td:last-child {
  border-right: 0;
}
.ux-table__inner {
  overflow-x: auto;
  height: auto;
}
.ux-table__inner::before, .ux-table__inner::after {
  content: "";
  opacity: 0;
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: calc(100% + 1px);
  pointer-events: none;
  transition: opacity 0.5s ease;
}
.ux-table__inner::before {
  background: linear-gradient(to left, rgba(255, 255, 255, 0) 0, rgba(0, 0, 0, 0.1) 100%);
}
.ux-table__inner::after {
  right: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.05) 0, #fff 100%);
}
.ux-table--non-fixed-column .ux-table__inner::before {
  background: linear-gradient(to left, rgba(255, 255, 255, 0) 0, #fff 100%);
}
.ux-table__fixed-link {
  padding: 9px 2px 9px 8px;
  transform: translate(-50%, -50%);
  position: absolute;
  right: -3px;
  top: 50%;
  display: none;
}
.ux-table--has-left-shadow .ux-table__inner::before {
  opacity: 1;
}
.ux-table--has-right-shadow .ux-table__inner::after {
  opacity: 1;
}
.ux-table--full-width table {
  min-width: 100%;
}
.ux-table--is-fixed table {
  min-width: auto;
}
.ux-table--is-fixed .ux-table__fixed-link {
  display: inline-block;
}
.ux-table--is-fixed td:nth-child(1) {
  z-index: 1;
}
.ux-table--is-fixed td:nth-child(1):hover {
  z-index: 2;
}
@media only screen and (min-width: 768px) {
  .ux-table__copy-with-headline {
    display: block;
  }
}
.ux-table--margin-right {
  margin-right: 50px;
}